import React, { useState } from "react"
import Modal from "components/Modal/MaterialModal"

import { Button } from "reactstrap"
import useWindowsSize from "hooks/useWindowsSize"
import { modalStyle } from "constants/layout"

const Delete = ({
  onClick,
  modalText,
  modalHeader,
  icon = "mdi-delete",
  linkClassName = "text-danger",
  confirmColor = "danger",
  confirmText = "Eliminar",
  title,
}) => {
  const [modal, setModal] = useState(false)
  const { isMobile } = useWindowsSize()

  const toggle = () => setModal(!modal)

  const customStyle = {
    ...modalStyle,
    width: isMobile ? "90%" : modalStyle.width,
  }

  return (
    <>
      <a className={linkClassName} onClick={toggle} title={title}>
        <i className={`me-2 mdi ${icon} font-size-18`} title={title} />
      </a>
      <Modal
        modalHeader={modalHeader ? modalHeader : "Eliminar documento"}
        toggle={toggle}
        modal={modal}
        customStyles={customStyle}
      >
        <p className="mb-3 mt-4">
          {!modalText
            ? `¿Está seguro que desea eliminar el documento?`
            : modalText}
        </p>
        <div className="d-flex gap-2 justify-content-end mt-4">
          <Button
            color={confirmColor}
            className="shadow-none"
            type="submit"
            onClick={() => {
              ;(onClick(), toggle())
            }}
          >
            {confirmText}
          </Button>
          <Button color="light" className="shadow-none" onClick={toggle}>
            Cancelar
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default Delete
